module.exports = __webpack_public_path__ + "static/appInto01-5df4c33996c5b87fb0fb5526c95a8b86.png";